<template>
  <metainfo></metainfo>
  <div id="post-card">
    <template v-if="conditions.isNoPermission()">
      <NoPermission />
    </template>

    <template v-else-if="conditions.isReadyPage()">
      <div class="container-xl">
        <div class="page-header d-print-none">
          <div class="row g-2 align-items-center">
            <div class="col-sm">
              <h2 class="page-title">
                <TitleInfo :data="{
                  post_id: getPostId(),
                  channel_id: bootData.channel_id,
                  status: bootData.status,
                  is_del: bootData.del,
                  scheduled_published: bootData.scheduled_published.value,
                  cnt_comments: bootData.cnt_comments,
                  type_id: bootData.type_id.type_id,
                }" @onCountSellStatistic="onCountSellTitle" @onClickChainStatistic="onClickChainTitle" />
              </h2>
            </div>
            <div class="col-auto">
              <div class="me-1">
                <ViewBtn :data="{
                  post_id: getPostId(),
                }" />
              </div>
            </div>
            <div class="col-auto" v-if="conditions.isShowPostInChain()">
              <div class="me-1">
                <PostInChain :post-id="chainObject.getId()" :type-id="chainObject.getTypeId()" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="page-body">
        <div class="container-xl">
          <div class="row">
            <div class="col">
              <PostComplaints :post-id="getPostId()" v-if="false" />
            </div>
          </div>

          <CommentModeration :payload="{
            categories: ['new'],
            limit: 20,
            title: 'Новые комментарии',
            filter: {
              post_id: getPostId(),
              object_type_id: commentModerationObject.getTypeId()
            }
          }" />

          <div class="row">
            <div class="col-md-8">
              <Transactions :data="transactions" />

              <template v-if="fields.isShow.promocodeLink()">
                <div class="mb-3" v-if="bootData.promocode_agregator.has">
                  <PromocodeLink :payload="{
                    post_id: getPostId(),
                    post_type_id: 1,
                    post_bind: bootData.promocode_agregator.has,
                    coupon_id: bootData.promocode_agregator.coupon_id,
                    source_id: bootData.promocode_agregator.source_id,
                  }"  :key="updateInfo" />
                </div>
            </template>

              <div class="mb-3" v-if="fields.isShow.typeId()">
                <TypeId :payload="{
                  type_id: bootData.type_id.type_id,
                  sub_type_ids: bootData.type_id.sub_type_ids,
                  validations: validations
                }" @onChange="events.onChangeTypeId" />
              </div>

              <div class="mb-3" v-if="fields.isShow.title()">
                <Title :payload="{
                  val: bootData.title
                }" @onChange="events.onChangeTitle" />
              </div>

              <div class="mb-2" v-if="fields.isShow.activateLink()">
                <ActivateLink
                    :payload="{
                      link: bootData.activate_link,
                      action_link: bootData.action_activate_link,
                      type_id: bootData.type_id.type_id,
                    }"
                    @onChange="events.onChangeActivateLink"
                    @onFindShop="events.onFindShopActivateLink"
                />
              </div>

              <div class="mb-3" v-if="fields.isShow.content()">
                <Editor
                    @onChange="events.onChangeContent"
                    :validations="validations"
                    :content="bootData.content"
                    :entity_id="getPostId()"
                    :show_bubble_menu="isShowBubbleMenu()"
                    :show_floating_menu="isShowFloatingMenu()"
                />
              </div>

              <div class="mb-3" v-if="conditions.isViewPostSaveBlock()">
                <ProcessSave :process="isSavingProcess()" />
              </div>

              <div class="mt-2" v-if="fields.isShow.imageMulti()">
                <ImageMulti :images="bootData.images" :post-id="getPostId()" @onChange="events.onChangeImage" @onDelete="events.onDeleteImage" />
              </div>
            </div>
            <div class="col-md-4">
              <Info :post-id="getPostId()" :key="updateInfo" />

              <div class="mt-2" v-if="fields.isShow.shopId()">
                <Shops :data="{
                  val: bootData.shop_id,
                  validations: validations
                }" @onChange="events.onChangeShopId" />
              </div>

              <div class="mt-2" v-if="fields.isShow.tagsId()">
                <Tags :data="{
                  val: bootData.tags_id,
                  validations: validations
                }" @onChange="events.onChangeTagsId" />
              </div>

              <div class="mt-2" v-if="fields.isShow.ratingArticle()">
                <RatingArticle :payload="{
                  val: bootData.post_article.rating
                }" @onChange="events.onChangeRatingArticle" />
              </div>

              <div class="mt-2" v-if="fields.isShow.categoryMulti()">
                <CategoryMulti :payload="{
                  val: bootData.category_multi
                }" @onChange="events.onChangeCategoryMulti"/>
              </div>

              <div class="mt-2" v-if="fields.isShow.categoryId()">
                <Category :payload="{
                  val: bootData.category_id,
                  validations: validations
                }" @onChange="events.onChangeCategoryId" />
              </div>

              <div class="mt-2" v-if="fields.isShow.typeVisibility()">
                <TypeVisibility :payload="{
                  val: bootData.type_visibility,
                }" @onChange="events.onChangeTypeVisibility" />
              </div>

              <div class="mt-2" v-if="fields.isShow.typePublish()">
                <TypePublish :payload="{
                  val: bootData.type_publish,
                }" @onChange="events.onChangeTypePublish" />
              </div>

              <div class="mt-2" v-if="fields.isShow.typeOrder()">
                <TypeOrder :payload="{
                  first_order: bootData.type_order.first_order,
                  repeat_order: bootData.type_order.repeat_order
                }" @onChange="events.onChangeTypeOrder" />
              </div>

              <div class="mt-2" v-if="fields.isShow.saleType()">
                <SaleType :payload="salePayload" @onChange="events.onChangeSaleType" />
              </div>

              <div class="mt-2" v-if="fields.isShow.timeAction()">
                <TimeAction :payload="{
                  start: bootData.time_action.start,
                  end: bootData.time_action.end,
                }" @onChange="events.onChangeTimeAction" />
              </div>

              <div class="mt-2" v-if="fields.isShow.promocode()">
                <Promocode :payload="{
                  val: bootData.promocode
                }" @onChange="events.onChangePromocode" />
              </div>

              <div class="mt-2" v-if="fields.isShow.imageSingle()">
                <ImageSingle :has-video="false" :src="getFirstImage(bootData?.images)" :post-id="getPostId()" @onChange="events.onChangeImage" @onDelete="events.onDeleteImage" />
              </div>

              <div class="mt-2" v-if="fields.isShow.isPartnerLinks()">
                <IsPartnerLinks :validations="validations" :data="{
                  enable: bootData.is_partner_links,
                }" @onChange="events.onChangeIsPartnerLinks" />
              </div>

              <div class="mt-2" v-if="fields.isShow.typeCommerce()">
                <TypeCommerce :data="{
                  val: bootData.type_commerce,
                  validations: validations
                }" @onChange="events.onChangeTypeCommerce" />
              </div>

              <div class="mt-2" v-if="fields.isShow.seo()">
                <Seo :payload="{
                  title: bootData.seo.title,
                  description: bootData.seo.description
                }" @onChange="events.onChangeSeo" />
              </div>

              <div class="mt-2" v-if="fields.isShow.slug() && isShowSlug()">
                <Slug :payload="{
                    val: bootData.slug,
                    post_id: getPostId(),
                    title: bootData.title,
                  }" @onChange="events.onChangeSlug" @onSync="events.onSyncSlug" />
              </div>

              <div class="mt-2" v-if="fields.isShow.markAd()">
                <template v-if="isMarkAdShow()">
                  <MarkAd :payload="{
                    post_id: getPostId(),
                    post_status: getPostStatus(),
                    query: getQuery(),
                    channel_id: getChannelId(),
                    type_id: getTypeId()
                  }" @onChangeAuto="events.onChangeMarkAdAuto" />
                </template>
              </div>

              <div class="mt-2" v-if="fields.isShow.variantId()">
                <VariantId :validations="validations" :data="{
                    val: bootData.variant_id,
                  }" @onChange="events.onChangeVariantId" />
              </div>

              <div class="card mt-2" v-if="conditions.isShowBtns()">
                <div class="card-body">
                  <template v-if="conditions.isShowPrePublishedBtn()">
                    <PostRepublished :type="'site'" :type_id="getTypeId()" :query="getQuery()" @onRepublished="events.onPostRepublished()" />
                  </template>
                  <template v-if="conditions.isShowCancelBtn()">
                    <PostCancel :data="{
                      post_id: getPostId(),
                    }" @onCancel="events.onPostCancel()" />
                  </template>
                  <template v-if="conditions.isShowScheduledPublishedModalBtn()">
                    <a href="#" class="btn btn-warning w-100 mb-3" :class="{ 'disabled': conditions.isDisabledScheduledPublishedModalBtn() }" data-bs-toggle="modal" data-bs-target="#scheduled-published" @click="events.onShowModal()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-forward-up">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 14l4 -4l-4 -4" />
                        <path d="M19 10h-11a4 4 0 1 0 0 8h1" />
                      </svg>
                      Опубликовать
                    </a>
                  </template>
                  <template v-if="conditions.isShowSaveBtn()">
                    <button class="btn btn-green w-100 mb-3" :class="{ 'disabled': conditions.isDisabledSaveBtn() }" @click="events.onSaveNow">
                      <span class="spinner-border spinner-border-sm me-2" v-show="conditions.isShowLoadingSaveBtn()"></span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-device-floppy">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2" />
                        <path d="M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                        <path d="M14 4l0 4l-6 0l0 -4" />
                      </svg>
                      Сохранить
                    </button>
                  </template>
                  <template v-if="conditions.isShowInDraftBtn()">
                    <PostInDraft :data="{
                      post_id: getPostId(),
                    }" @onDraft="events.onPostDraft()" />
                  </template>
                  <template v-if="conditions.isShowInPublishedBtn()">
                    <PostInPublished :payload="{
                        post_id: getPostId(),
                      }" @onChange="events.onPostPublished" />
                  </template>
                  <template v-if="conditions.isShowRemoveBtn()">
                    <PostRemove :data="{
                      post_id: getPostId(),
                      post_in_chain: bootData.has_in_chain,
                      status: bootData.status,
                      type: 'site',
                    }" @onPostRemove="events.onPostRemove()" />
                  </template>
                  <template v-if="conditions.isShowRemoveForceBtn()">
                    <div class="mt-4">
                      <PostRemoveForce :data="{
                        post_id: getPostId(),
                        status: bootData.status,
                      }" @onPostRemove="events.onPostRemove()" />
                    </div>
                  </template>
                </div>
              </div>

              <div class="mt-2" v-if="fields.isShow.commentAllow()">
                <CommentAllow :validations="validations" :data="{
                  enable: bootData.comment_allow,
                }" @onChange="events.onChangeCommentAllow" />
              </div>
            </div>

            <template v-if="fields.isShow.faq()">
              <div class="mt-2">
                <Faq :data="{
                  val: bootData.post_article.faq,
                }" @onUpdate="events.onChangeFaq"/>
              </div>
            </template>

            <template v-if="conditions.isShowObjectChain()">
              <div class="mt-2">
                <PostRefPosts :data="{
                  id: chainObject.getId(),
                  channel_id: chainObject.getChannelId(),
                  status: chainObject.getStatus(),
                  del: chainObject.getDel(),
                }" :type-id="chainObject.getTypeId()" />
              </div>
            </template>
            <template v-if="conditions.isShowComposites()">
              <div class="mt-2">
                <Composites :data="{
                  postId: getPostId(),
                  hasInChain: bootData.has_in_chain,
                }" />
              </div>
            </template>
            <template v-if="conditions.isShowPostRefLinks()">
              <div class="mt-2">
                <PostRefLinks :data="{
                  postId: getPostId()
                }" />
              </div>
            </template>
            <template v-if="conditions.isUpdatePost()">
              <div class="mt-2">
                <CommentModeration :payload="{
                  categories: ['approved', 'rejected', 'removed'],
                  limit: 20,
                  force_show: true,
                  title: 'Промодерированные комментарии',
                  filter: {
                    post_id: getPostId(),
                    object_type_id: commentModerationObject.getTypeId()
                  }
                }" />
              </div>
            </template>
          </div>

          <div class="modal modal-blur fade" id="scheduled-published" tabindex="-1" role="dialog" v-show="conditions.isViewPublishedWindow()">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Опубликовать</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="closeModal"></button>
                </div>
                <div class="modal-body">
                  <div class="accordion">
                    <div class="accordion-item">
                      <h2 class="accordion-header" @click="accordion.onClick">
                        <button class="accordion-button" :class="{ 'collapsed': accordion.item1 === false }" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-1" aria-expanded="false">
                          Опубликовать отложено
                        </button>
                      </h2>
                      <div id="collapse-1" class="accordion-collapse collapse" :class="{ 'show': accordion.item1 === true }" data-bs-parent="#accordion-example" style="">
                        <div class="accordion-body pt-0">
                          <ScheduledPublished :validations="validations" :enable="bootData.scheduled_published.enable" :datetime="bootData.scheduled_published.value" @onChange="events.onChangeScheduledPublished" />
                          <button class="btn btn-warning w-100" :class="{ 'disabled': conditions.isDisabledScheduledPublishedBtn() }" @click="events.onSaveScheduled(true)">
                            <span class="spinner-border spinner-border-sm me-2" v-show="conditions.isShowLoadingScheduledPublishedBtn()"></span>
                            Опубликовать отложено
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" @click="accordion.onClick">
                        <button class="accordion-button" :class="{ 'collapsed': accordion.item2 === false }" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-2" aria-expanded="true">
                          Опубликовать сейчас
                        </button>
                      </h2>
                      <div id="collapse-2" class="accordion-collapse collapse" :class="{ 'show': accordion.item2 === true }" data-bs-parent="#accordion-example" style="">
                        <div class="accordion-body pt-0">
                          <button class="btn btn-danger w-100" :class="{ 'disabled': conditions.isDisabledPublishedNowBtn() }" @click="events.onPublishedNow(true)">
                            <span class="spinner-border spinner-border-sm me-2" v-show="conditions.isShowLoadingPublishedNowBtn()"></span>
                            Опубликовать сейчас
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="page-body">
        <div class="container-xl">
          <div class="row">
            <div class="mb-3">
              <div class="loader-posts">
                <div class="spinner-border"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {defineComponent, onMounted, ref, reactive, watch, computed} from "vue"
import {useMeta} from "vue-meta"
import {useRoute, useRouter} from "vue-router"

import cfg from "@/services/Config"
import Api from "./services/Api"
import Helper from "@/services/Helper"
import ImageSingle from "@/modules/post/components/site_image_single/SiteImageSingle"
import ImageMulti from "@/modules/post/components/site_image_multi/SiteImageMulti"
import Title from "@/modules/post/components/title/Index"
import Slug from "@/modules/post/components/slug/Index"
import TitleInfo from "@/modules/post/components/title_info/Title"
import {isSavingProcess, autosaveInit, addStackChanges, autosaveStop} from "@/modules/post/pages/site/edit/services/auto_save"
import createDraftInit from "@/modules/post/pages/site/edit/services/create_draft"
import Editor from "@/components/editor/Editor"
import ScheduledPublished from "@/modules/post/components/scheduled_published/ScheduledPublished"
import ProcessSave from "@/modules/post/components/process_save/ProcessSave"
import PostRefPosts from "@/components/object_chains/PostRefPosts"
import PostRemove from "@/modules/post/components/remove/Remove"
import PostRemoveForce from "@/modules/post/components/remove_force/Index"
import PostCancel from "@/modules/post/components/cancel/Cancel"
import PostInDraft from "@/modules/post/components/in_draft/InDraft"
import PostRepublished from "@/modules/post/components/republished/Republished"
import Composites from "@/modules/post/components/composites/Composites"
import PostRefLinks from "@/modules/post/components/ref_links/RefLinks"
import PostInChain from "@/components/post_in_chain/PostInChain"
import PostStoreCommon from "@/modules/post/pages/posts/services/PostStoreCommon"
import PostPermission from "@/modules/post/services/Permission"
import NoPermission from "@/modules/auth/pages/no_permission/Index"
import Info from "@/modules/post/components/info/Index"
import IsPartnerLinks from "@/modules/post/components/is_partner_links/IsPartnerLinks"
import CommentAllow from "@/modules/post/components/comment_allow/CommentAllow"
import TypeCommerce from "@/modules/post/components/type_commerce/TypeCommerce"
import Transactions from "@/modules/post/components/transactions/Transactions"
import PostComplaints from "@/modules/post/components/complaints/PostComplaints"
import Shops from "@/modules/post/components/shops/Index"
import Tags from "@/modules/post/components/tags/Index"
import Category from "@/modules/post/components/category/Index"
import CommentModeration from "@/components/comment_moderation/SiteCommentModeration"
import Notify from "@/services/Notify"
import MarkAd from "@/modules/post/components/mark_ad/Index"
import TypeId from "@/modules/post/components/type_id/Index"
import TypeVisibility from "@/modules/post/components/type_visibility/Index"
import TypePublish from "@/modules/post/components/type_publish/Index"
import TypeOrder from "@/modules/post/components/type_order/Index"
import SaleType from "@/modules/post/components/sale_type/Index"
import Promocode from "@/modules/post/components/promocode/Index"
import ActivateLink from "@/modules/post/components/activate_link/Index"
import TimeAction from "@/modules/post/components/time_action/Index"
import {
  notesTypeId,
  promocodeTypeId,
  salesTypeId,
  offersTypeId,
  freeTypeId,
  foodAndProductsTypeId,
  banksTypeId,
  gamesTypeId,
  raffleTypeId, articlesTypeId
} from "@/modules/post/services/TypeId"
import Permission from "@/modules/users/services/Permission"
import CategoryMulti from '@/modules/post/components/category_multi/Index'
import ViewBtn from "@/modules/post/components/view_btn/ViewBtn.vue"
import PostInPublished from "@/modules/post/components/in_published/InPublished"
import PromocodeLink from "@/modules/post/components/promocode_link/Index"
import RatingArticle from "@/modules/post/components/rating_article/Index"
import Faq from "@/modules/post/components/faq/Faq"
import Seo from "@/modules/post/components/seo/Index"
import VariantId from "@/modules/post/components/variant_id/VariantId"

export default defineComponent({
  name: "SiteUpdateCreate",
  components: {
    PromocodeLink,
    ViewBtn,
    CommentModeration,
    Transactions,
    TypeCommerce,
    ProcessSave,
    ScheduledPublished,
    Editor,
    ImageSingle,
    PostRefPosts,
    Composites,
    PostRefLinks,
    TitleInfo,
    PostRemove,
    PostRemoveForce,
    PostInChain,
    NoPermission,
    Info,
    IsPartnerLinks,
    PostCancel,
    PostInDraft,
    PostRepublished,
    PostComplaints,
    Shops,
    Tags,
    Category,
    CommentAllow,
    MarkAd,
    TypeId,
    Title,
    Slug,
    TypeVisibility,
    TypePublish,
    TypeOrder,
    SaleType,
    Promocode,
    TimeAction,
    ImageMulti,
    ActivateLink,
    CategoryMulti,
    PostInPublished,
    RatingArticle,
    Faq,
    Seo,
    VariantId,
  },
  setup() {
    // todo перечитать весь код

    const route = useRoute()
    const router = useRouter()

    let readyPage = ref(false)
    let validations = ref({})
    let postId = ref(null)
    let saving = ref(false)
    let closeModal = ref(null)
    let error = ref(false)
    let noPermission = ref(false)
    let updateInfo = ref(0)

    let chainObject = {
      getId: () => {
        return getPostId()
      },
      getChannelId: () => {
        return bootData.channel_id
      },
      getStatus: () => {
        if (bootData.status === "published") {
          return "published"
        } else if (bootData.status === "draft") {
          return "draft"
        } else if (bootData.status === "deleted") {
          return "deleted"
        } else if (bootData.status === "scheduled") {
          return "scheduled"
        } else if (bootData.status === "prePublished") {
          return "prePublished"
        } else if (bootData.status === "preDeleted") {
          return "preDeleted"
        } else if (bootData.status === "canceled") {
          return "canceled"
        } else if (bootData.status === "preDeletedForce") {
          return "preDeletedForce"
        } else {
          throw Error("Неопределен статус")
        }
      },
      getDel: () => {
        if (bootData.del === 1) {
          return 1
        } else if (bootData.del === 0) {
          return 0
        } else {
          throw Error("Неопределен признак выключения")
        }
      },
      getTypeId: () => {
        return cfg._("object_chains", "types", "post")
      }
    }

    let commentModerationObject = {
      getTypeId: () => {
        return cfg._("comment_moderation", "types", "post")
      }
    }

    const typeId = computed(() => {
      const value = route?.query?.type_id
      return !Helper.isEmpty(value) ? value : 6
    })

    let bootData = reactive({
      content: null,
      image: null,
      scheduled_published: {
        value: null,
        enable: null,
      },
      status: null,
      del: null,
      channel_id: null,
      has_in_chain: null,
      is_partner_links: 1,
      comment_allow: 1,
      type_commerce: null,
      variant_id: null,
      shop_id: null,
      tags_id: [],
      category_id: -1,
      cnt_comments: 0,
      type_id: {
        type_id: typeId,
        sub_type_ids: [],
      },
      title: null,
      slug: null,
      type_visibility: 1,
      type_publish: 1,
      type_order: {
        first_order: false,
        repeat_order: false,
      },
      price: {
        new: null,
        old: null,
      },
      promocode: null,
      time_action: {
        start: null,
        end: null,
      },
      activate_link: null,
      action_activate_link: false,
      category_multi: [],
      sale_type_id: 0,
      sale_type_value: null,
      has_promocode_agregator: false,
      promocode_agregator: {
        has: false,
        coupon_id: null,
        source_id: null,
      },
      rating_article: {
        rating: null,
        faq: [],
      },
      seo: {
        title: '',
        description: '',
      },
    })

    let setters = {
      setImage: (val) => {
        bootData.images = val
      },
      setContent: (val) => {
        bootData.content = val
      },
      setScheduledPublished: (val) => {
        bootData.scheduled_published.value = val
      },
      setScheduledPublishEnable: (val) => {
        bootData.scheduled_published.enable = val
      },
      setIsPartnerLinks: (val) => {
        bootData.is_partner_links = val
      },
      setCommentAllow: (val) => {
        bootData.comment_allow = val
      },
      setTypeCommerce: (val) => {
        bootData.type_commerce = val
      },
      setVariantId: (val) => {
        bootData.variant_id = val
      },
      setShopId: (val) => {
        bootData.shop_id = val
      },
      setTagsId: (val) => {
        bootData.tags_id = val
      },
      setCategoryId: (val) => {
        bootData.category_id = val
      },
      setTypeId: (val) => {
        bootData.type_id.type_id = val
      },
      setSubTypeIds: (val) => {
        bootData.type_id.sub_type_ids = val
      },
      setTitle: (val) => {
        bootData.title = val
      },
      setSlug: (val) => {
        bootData.slug = val
      },
      setTypeVisibility: (val) => {
        bootData.type_visibility = val
      },
      setTypePublish: (val) => {
        bootData.type_publish = val
      },
      setTypeOrderFirst: (val) => {
        bootData.type_order.first_order = val
      },
      setTypeOrderRepeat: (val) => {
        bootData.type_order.repeat_order = val
      },
      setSaleTypeId: (val) => {
        bootData.sale_type_id = val
      },
      setSaleTypeValue: (val) => {
        bootData.sale_type_value = val
      },
      setPriceNew: (val) => {
        bootData.price.new = val
      },
      setPriceOld: (val) => {
        bootData.price.old = val
      },
      setPromocode: (val) => {
        bootData.promocode = val
      },
      setTimeActionStart: (val) => {
        bootData.time_action.start = val
      },
      setTimeActionEnd: (val) => {
        bootData.time_action.end = val
      },
      setActivateLink: (val) => {
        bootData.activate_link = val
      },
      setActionActivateLink: (val) => {
        bootData.action_activate_link = val
      },
      setCategoryMulti: (val) => {
        bootData.category_multi = val
      },
      setRatingArticle: (val) => {
        bootData.post_article.rating = val
      },
      setFaq: (val) => {
        bootData.post_article.faq = val
      },
      setTitleSeo: (val) => {
        bootData.seo.title = val
      },
      setDescriptionSeo: (val) => {
        bootData.seo.description = val
      },
    }

    let accordion = reactive({
      item1: false,
      item2: true,
      onClick() {
        accordion.item1 = !accordion.item1
        accordion.item2 = !accordion.item2
      },
    })

    let conditions = {
      statuses: {
        // todo пересмотреть статусы, для сайта ни будут скорее всего другие
        isDraft: () => {
          return bootData.status === "draft"
        },
        isPublished: () => {
          return bootData.status === "published"
        },
        isScheduled: () => {
          return bootData.status === "scheduled"
        },
        isPrePublished: () => {
          return bootData.status === "prePublished"
        },
        isPreDeleted: () => {
          return bootData.status === "preDeleted"
        },
        isCanceled: () => {
          return bootData.status === "canceled"
        },
        isDeleted: () => {
          return bootData.status === "deleted"
        },
      },
      isReadyPage: () => {
        return readyPage.value === true
      },
      isNoPermission: () => {
        return noPermission.value === true
      },
      isViewPostSaveBlock: () => {
        return hasPostId() && conditions.statuses.isDraft() && !conditions.statuses.isDeleted()
      },
      isPostRemoved: () => {
        return conditions.statuses.isDeleted()
      },
      isNotPostRemoved: () => {
        return !conditions.isPostRemoved()
      },
      isNotError: () => {
        return !isError()
      },
      isShowCancelBtn: () => {
        return hasPostId() && (conditions.statuses.isPreDeleted() || conditions.statuses.isPrePublished())
      },
      isShowRemoveBtn: () => {
        return hasPostId() && !conditions.statuses.isDeleted() && !conditions.statuses.isCanceled() && !conditions.statuses.isPrePublished()
      },
      isShowRemoveForceBtn: () => {
        return hasPostId() &&
            isAllowDeleteForce() &&
            !conditions.statuses.isDeleted() &&
            !conditions.statuses.isCanceled() &&
            !conditions.statuses.isPrePublished()
      },
      isShowScheduledPublishedModalBtn: () => {
        return (conditions.statuses.isDraft() || conditions.statuses.isScheduled()) && !conditions.statuses.isDeleted() && !conditions.statuses.isCanceled()
      },
      isDisabledScheduledPublishedModalBtn: () => {
        return !hasPostId()
      },
      isShowSaveBtn: () => {
        return (
                conditions.statuses.isPublished() ||
                conditions.statuses.isScheduled() ||
                conditions.statuses.isDeleted()
            ) &&
            !conditions.statuses.isCanceled()
      },
      isDisabledSaveBtn: () => {
        return conditions.isSaving()
      },
      isShowLoadingSaveBtn: () => {
        return conditions.isSaving()
      },
      isShowPrePublishedBtn: () => {
        return hasPostId() && conditions.statuses.isPrePublished()
      },
      isViewPublishedWindow: () => {
        return (conditions.statuses.isDraft() || conditions.statuses.isScheduled()) && hasPostId()
      },
      isDisabledScheduledPublishedBtn: () => {
        return conditions.isSaving()
      },
      isShowLoadingScheduledPublishedBtn: () => {
        return conditions.isSaving()
      },
      isDisabledPublishedNowBtn: () => {
        return conditions.isSaving()
      },
      isShowLoadingPublishedNowBtn: () => {
        return conditions.isSaving()
      },
      isShowInDraftBtn: () => {
        return conditions.statuses.isScheduled() || conditions.statuses.isCanceled()
      },
      isShowInPublishedBtn: () => {
        return conditions.statuses.isDeleted() || conditions.statuses.isCanceled()
      },
      isRunAutoSave: () => {
        return conditions.statuses.isDraft() && !conditions.statuses.isDeleted()
      },
      isSaving: () => {
        return saving.value === true
      },
      isUpdatePost: () => {
        return hasPostId()
      },
      isShowObjectChain: () => {
        return conditions.isUpdatePost() && getTypeId() !== articlesTypeId
      },
      isShowComposites: () => {
        return conditions.isUpdatePost() && getTypeId() !== articlesTypeId
      },
      isShowPostRefLinks: () => {
        return conditions.isUpdatePost() && getTypeId() !== articlesTypeId
      },
      isShowPostInChain: () => {
        return hasPostId() && conditions.isNotPostRemoved()
      },
      isShowBtns: () => {
        return (hasPostId() && conditions.isNotError()) &&
            (
              conditions.isShowPrePublishedBtn() ||
              conditions.isShowCancelBtn() ||
              conditions.isShowScheduledPublishedModalBtn() ||
              conditions.isShowSaveBtn() ||
              conditions.isShowInDraftBtn() ||
              conditions.isShowRemoveBtn() ||
              conditions.isShowRemoveForceBtn() ||
              conditions.isShowInPublishedBtn()
            )
      },
      isShowScheduledRemove: () => {
        return hasPostId() && conditions.isNotPostRemoved()
      },
      isTypeNotes: () => {
        return getTypeId() === notesTypeId
      },
    }

    let events = {
      onShowModal: () => {
        accordion.item1 = false
        accordion.item2 = true
      },
      onChangeImage: (val) => {
        setters.setImage(val)
      },
      onDeleteImage: () => {
        setters.setImage(null)
      },
      onChangeContent: (content) => {
        setters.setContent(content)
        addStackChanges({content: JSON.stringify(content !== null ? content : "")})
      },
      onChangeScheduledPublished: (val) => {
        let v = val?.val
        let setUser = val?.set_user

        if (setUser === true) {
          setters.setScheduledPublished(v)
          addStackChanges({scheduled_published: v})
        }
      },
      onSaveScheduled: (fromModal = false) => {
        events.onSave(fromModal, "scheduled")
      },
      onPublishedNow: (fromModal = false) => {
        events.onSave(fromModal, "published")
      },
      onSaveNow: (fromModal = false) => {
        if (confirm("Вы действительно хотите сохранить?")) {
          events.onSave(fromModal, "save")
          runRenderInfo()
        }
      },
      onSave: (fromModal, type) => {
        autosaveStop()
        setValidation([])
        startSaving()

        factorySave(getQuery({}), type, bootData.type_id.type_id).then(() => {
          if (fromModal === true) {
            closeModalWindow()
          }

          // todo ХАК! небольшая отсрочка при загрузки от api
          // todo чтобы backend успел отложенно сделать все свои действия
          setTimeout(() => {
            getItem(getPostId()).then((resp) => {
              initBootData(resp)
              runRenderInfo()
            }).then(() => {
              if (type === "scheduled") {
                Notify.success("Запланировано")
              } else if (type === "published") {
                Notify.success("Опубликовано")
              } else if (type === "save") {
                Notify.success("Сохранено")
              }

              stopSaving()
            })
          }, 1500)
        }).catch((resp) => {
          stopSaving()
          setValidation(resp.response.data?.validations)
          runRenderInfo()
        })
      },
      onPostRemove: () => {
        getItem(getPostId()).then((resp) => {
          autosaveStop()
          initBootData(resp)
          runRenderInfo()
        })
      },
      onPostCancel: () => {
        getItem(getPostId()).then((resp) => {
          initBootData(resp)
          runRenderInfo()
        })
      },
      onPostDraft: () => {
        getItem(getPostId()).then((resp) => {
          initBootData(resp)
          runRenderInfo()
          createAutosave(getPostId())
        })
      },
      onPostPublished: async (val) => {
        if (!val) {
          return
        }

        let resp = await getItem(getPostId())
        initBootData(resp)
        runRenderInfo()
      },
      onPostRepublished: () => {
        getItem(getPostId()).then((resp) => {
          initBootData(resp)
          runRenderInfo()
        })
      },
      onChangeIsPartnerLinks: (val) => {
        setters.setIsPartnerLinks(val)
        addStackChanges({is_partner_links: val})
      },
      onChangeCommentAllow: (val) => {
        setters.setCommentAllow(val)
        addStackChanges({comment_allow: val})
      },
      onChangeTypeCommerce: (val) => {
        setters.setTypeCommerce(val)
        addStackChanges({type_commerce: val})
      },
      onChangeVariantId: (val) => {
        setters.setVariantId(val)
        addStackChanges({variant_id: val})
      },
      onChangeShopId: (val) => {
        setters.setShopId(val)
        addStackChanges({shop_id: val})
      },
      onChangeTagsId: (val) => {
        setters.setTagsId(val)
        addStackChanges({tags_id: val})
      },
      onChangeCategoryId: (val) => {
        setters.setCategoryId(val)
        addStackChanges({category_id: val}, bootData)
      },
      onChangeTypeId: (val) => {
        setters.setTypeId(val["type_id"])
        setters.setSubTypeIds(val["sub_type_ids"])
        addStackChanges({type_id: val["type_id"]})
        addStackChanges({sub_type_ids: val["sub_type_ids"]})
        onChangeTypeId(val["type_id"])
      },
      onChangeTitle: (val) => {
        setters.setTitle(val)
        addStackChanges({title: val})
      },
      onChangeSlug: (val) => {
        setters.setSlug(val)
        addStackChanges({slug: val})
      },
      onSyncSlug: async (val) => {
        if (val === true) {
          let resp = await getItem(getPostId())

          initBootData(resp)
          runRenderInfo()

          Notify.success("Url синхронизирован по заголовку")
        }
      },
      onChangeTypeVisibility: (val) => {
        setters.setTypeVisibility(val)
        addStackChanges({type_visibility: val})
      },
      onChangeTypePublish: (val) => {
        setters.setTypePublish(val)
        addStackChanges({type_publish: val})
      },
      onChangeTypeOrder: (val) => {
        let firstOrder = val?.first_order ?? false
        let repeatOrder = val?.repeat_order ?? false

        setters.setTypeOrderFirst(firstOrder)
        setters.setTypeOrderRepeat(repeatOrder)
        addStackChanges({first_order: firstOrder})
        addStackChanges({repeat_order: repeatOrder})
      },
      onChangeSaleType: (val) => {
        setters.setSaleTypeId(val["sale_type_id"])
        setters.setSaleTypeValue(val["sale_type_value"])
        setters.setPriceNew(val["new_price"])
        setters.setPriceOld(val["old_price"])

        addStackChanges({sale_type_id: val["sale_type_id"]})
        addStackChanges({sale_type_value: val["sale_type_value"]})
        addStackChanges({price_new: val["new_price"]})
        addStackChanges({price_old: val["old_price"]})
      },
      onChangePromocode: (val) => {
        setters.setPromocode(val)
        addStackChanges({promocode: val})
      },
      onChangeTimeAction: (val) => {
        setters.setTimeActionStart(val["start"])
        setters.setTimeActionEnd(val["end"])
        addStackChanges({time_action_start: val["start"]})
        addStackChanges({time_action_end: val["end"]})
      },
      onChangeActivateLink: (val) => {
        setters.setActivateLink(val?.link ?? "")
        setters.setActionActivateLink(val?.action_link ?? false)
        addStackChanges({activate_link: val?.link ?? ""}, bootData)
        addStackChanges({action_activate_link: val?.action_link}, bootData)
      },
      onChangeCategoryMulti: (val) => {
        setters.setCategoryMulti(val)
        addStackChanges({category_multi: val})
      },
      onFindShopActivateLink: (val) => {
        let shopId = val?.shop_id ?? null
        let findManyShop = val?.find_many_shop ?? false

        if (shopId === null) {
          Notify.info("Магазин не найден")
          return false
        }

        if (findManyShop === true) {
          Notify.info("По ссылке для активации найдено больше одного магазина")
          return false
        }

        // todo возможно тут лучше использовать метод для установки магазина
        bootData.shop_id = shopId

        Notify.success("Магазин определен")
      },
      onChangeRatingArticle: (val) => {
        setters.setRatingArticle(val)
        addStackChanges({rating_article: val})
      },
      onChangeFaq: (val) => {
        setters.setFaq(val)
        addStackChanges({faq: val})
      },
      onChangeSeo: (val) => {
        setters.setTitleSeo(val?.title ?? "")
        setters.setDescriptionSeo(val?.description ?? "")
        addStackChanges({title_seo: val?.title ?? ""}, bootData)
        addStackChanges({description_seo: val?.description ?? ""}, bootData)
      },
    }

    let transactions = reactive({
      element: {},
      post_id: null,
      channel_id: null,
    })

    let fields = {
      list: ref({
        "content": {"show": false},
        "is_partner_links": {"show": false},
        "comment_allow": {"show": false},
        "type_commerce": {"show": false},
        "variant_id": {"show": false},
        "shop_id": {"show": false},
        "tags_id": {"show": false},
        "category_id": {"show": false},
        "type_id": {"show": false},
        "sub_type_ids": {"show": false},
        "title": {"show": false},
        "slug": {"show": false},
        "type_visibility": {"show": false},
        "type_publish": {"show": false},
        "first_order": {"show": false},
        "repeat_order": {"show": false},
        "sale_type": {"show": false},
        "time_action_start": {"show": false},
        "time_action_end": {"show": false},
        "promocode": {"show": false},
        "image_single": {"show": false},
        "image_multi": {"show": false},
        "mark_ad": {"show": false},
        "activate_link": {"show": false},
        "category_multi": {"show": false},
        "promocode_link": {"show": false},
        "rating_article": {"show": false},
        "faq": {"show": false},
        "seo": {"show": false},
      }),
      isShow: {
        content: () => {
          return fields.list.value.content.show
        },
        isPartnerLinks: () => {
          return fields.list.value.is_partner_links.show
        },
        commentAllow: () => {
          return fields.list.value.comment_allow.show
        },
        typeCommerce: () => {
          return fields.list.value.type_commerce.show
        },
        variantId: () => {
          return fields.list.value.variant_id.show
        },
        shopId: () => {
          return fields.list.value.shop_id.show
        },
        tagsId: () => {
          return fields.list.value.tags_id.show
        },
        categoryId: () => {
          return fields.list.value.category_id.show
        },
        typeId: () => {
          return fields.list.value.type_id.show
        },
        title: () => {
          return fields.list.value.title.show
        },
        slug: () => {
          return fields.list.value.slug.show
        },
        typeVisibility: () => {
          return fields.list.value.type_visibility.show
        },
        typePublish: () => {
          return fields.list.value.type_publish.show
        },
        typeOrder: () => {
          return fields.list.value.first_order.show
        },
        saleType: () => {
          return fields.list.value.sale_type.show
        },
        timeAction: () => {
          return fields.list.value.time_action_start.show
        },
        promocode: () => {
          return fields.list.value.promocode.show
        },
        imageSingle: () => {
          return fields.list.value.image_single.show
        },
        imageMulti: () => {
          return fields.list.value.image_multi.show
        },
        markAd: () => {
          return fields.list.value.mark_ad.show
        },
        activateLink: () => {
          return fields.list.value.activate_link.show
        },
        categoryMulti: () => {
          return fields.list.value.category_multi.show
        },
        promocodeLink: () => {
          return fields.list.value.promocode_link.show
        },
        ratingArticle: () => {
          return fields.list.value.rating_article.show
        },
        faq: () => {
          return fields.list.value.faq.show
        },
        seo: () => {
          return fields.list.value.seo.show
        },
      },
    }

    let configs = {
      "types": {
        5: {
          "type_id": {},
          "content": {},
          "is_partner_links": {},
          "image_multi": {},
        },
        6: {
          "content": {},
          "is_partner_links": {},
          "comment_allow": {},
          "shop_id": {},
          "category_id": {},
          "type_id": {},
          "sub_type_ids": {},
          "title": {},
          "slug": {},
          "type_visibility": {},
          "type_publish": {},
          "sale_type": {},
          "time_action_start": {},
          "time_action_end": {},
          "promocode": {},
          "image_single": {},
          "mark_ad": {},
          "activate_link": {},
        },
        7: {
          "title": {},
          "slug": {},
          "content": {},
          "type_id": {},
          "promocode": {},
          "activate_link": {},
          "is_partner_links": {},
          "type_visibility": {},
          "type_publish": {},
          "sale_type": {},
          "first_order": {},
          "repeat_order": {},
          "shop_id": {},
          "mark_ad": {},
          "time_action_start": {},
          "time_action_end": {},
          "category_multi": {},
          "promocode_link": {},
        },
        8: {
          "content": {},
          "is_partner_links": {},
          "comment_allow": {},
          "shop_id": {},
          "category_id": {},
          "type_id": {},
          "sub_type_ids": {},
          "title": {},
          "slug": {},
          "type_visibility": {},
          "type_publish": {},
          "sale_type": {},
          "time_action_start": {},
          "time_action_end": {},
          "promocode": {},
          "image_single": {},
          "mark_ad": {},
          "activate_link": {},
        },
        9: {
          "content": {},
          "is_partner_links": {},
          "comment_allow": {},
          "shop_id": {},
          "category_id": {},
          "type_id": {},
          "sub_type_ids": {},
          "title": {},
          "slug": {},
          "type_visibility": {},
          "type_publish": {},
          "sale_type": {},
          "time_action_start": {},
          "time_action_end": {},
          "promocode": {},
          "image_single": {},
          "mark_ad": {},
          "activate_link": {},
        },
        10: {
          "content": {},
          "is_partner_links": {},
          "comment_allow": {},
          "shop_id": {},
          "category_id": {},
          "type_id": {},
          "sub_type_ids": {},
          "title": {},
          "slug": {},
          "type_visibility": {},
          "type_publish": {},
          "sale_type": {},
          "time_action_start": {},
          "time_action_end": {},
          "promocode": {},
          "image_single": {},
          "mark_ad": {},
          "activate_link": {},
        },
        12: {
          "content": {},
          "is_partner_links": {},
          "comment_allow": {},
          "shop_id": {},
          "category_id": {},
          "type_id": {},
          "sub_type_ids": {},
          "title": {},
          "slug": {},
          "type_visibility": {},
          "type_publish": {},
          "sale_type": {},
          "time_action_start": {},
          "time_action_end": {},
          "promocode": {},
          "image_single": {},
          "mark_ad": {},
          "activate_link": {},
        },
        13: {
          "content": {},
          "is_partner_links": {},
          "comment_allow": {},
          "shop_id": {},
          "category_id": {},
          "type_id": {},
          "sub_type_ids": {},
          "title": {},
          "slug": {},
          "type_visibility": {},
          "type_publish": {},
          "sale_type": {},
          "time_action_start": {},
          "time_action_end": {},
          "promocode": {},
          "image_single": {},
          "mark_ad": {},
          "activate_link": {},
        },
        14: {
          "content": {},
          "is_partner_links": {},
          "comment_allow": {},
          "shop_id": {},
          "category_id": {},
          "type_id": {},
          "sub_type_ids": {},
          "title": {},
          "slug": {},
          "type_visibility": {},
          "type_publish": {},
          "sale_type": {},
          "time_action_start": {},
          "time_action_end": {},
          "promocode": {},
          "image_single": {},
          "mark_ad": {},
          "activate_link": {},
        },
        15: {
          "content": {},
          "is_partner_links": {},
          "shop_id": {},
          "tags_id": {},
          "rating_article": {},
          "type_id": {},
          "title": {},
          "slug": {},
          "image_single": {},
          "mark_ad": {},
          "faq": {},
          "seo": {},
          "variant_id": {},
        },
      },
    }

    function onChangeTypeId(typeId) {
      renderFields(typeId)
    }

    watch(() => accordion.item1, (val) => {
      setters.setScheduledPublishEnable(val)
    })

    watch(() => bootData.scheduled_published.enable, () => {
      //accordion.item1 = (val === true)
      //accordion.item2 = (val === false)
    })

    watch(bootData, (val) => {
      PostStoreCommon.handle({
        "channel_id": val.channel_id,
        "route_name": "PostCreateUpdate",
      })

      renderFields(bootData.type_id["type_id"])
    })

    onMounted(async () => {
      autosaveStop()

      if (route.params.id) {
        setPostId(parseInt(route.params.id))
      }

      if (conditions.isUpdatePost()) {
        useMeta({title: "Редактирование поста"})

        getItem(getPostId()).then(async (resp) => {
          await initBootData(resp)

          if (!isUpdatePermission(bootData.channel_id)) {
            await router.push({name: "PostView", params: { id: getPostId() }})
            return
          }

          readyPageOn()

          if (conditions.isRunAutoSave()) {
            createAutosave(getPostId())
          }
        })
      } else {
        useMeta({title: "Создание поста"})

        let channelId, shopId, promocode, untilDate, couponId, sourceId

        channelId = parseInt(route.params["channel_id"])
        if (Helper.isEmpty(channelId)) {
          throw Error("Отсутствует канал")
        }

        if (!Helper.isEmpty(route.query["shop_id"])) {
          shopId = parseInt(route.query["shop_id"])
        }

        if (!Helper.isEmpty(route.query["promocode"])) {
          promocode = route.query["promocode"]
        }

        if (!Helper.isEmpty(route.query["until_date"])) {
          untilDate = route.query["until_date"]
        }

        if (!Helper.isEmpty(route.query["coupon_id"])) {
          couponId = parseInt(route.query["coupon_id"])
        }

        if (!Helper.isEmpty(route.query["source_id"])) {
          sourceId = parseInt(route.query["source_id"])
        }

        let postId = await createDraft(
            channelId,
            typeId.value,
            shopId,
            promocode,
            untilDate,
            couponId,
            sourceId,
        )

        let postData = await getItem(postId)

        initBootData(postData)

        if (!isUpdatePermission(bootData.channel_id)) {
          setNoPermission()
        }

        let thisTypeId = cfg._("object_chains", "types", "post")

        bindChainPost(
            postId,
            route.query["in_chain_object_id"],
            thisTypeId,
            route.query["in_chain_type_id"],
        )

        createAutosave(postId)
        setPostId(postId)
        changeUrl(postId)
        readyPageOn()
      }
    })

    function renderFields(typeId) {
      for (const key in fields.list.value) {
        fields.list.value[key].show = false
      }

      const data = configs.types?.[typeId]
      if (!data) {
        return
      }

      for (const key in fields.list.value) {
        if (Object.hasOwn(data, key)) {
          fields.list.value[key].show = true
        }
      }
    }

    function runRenderInfo() {
      updateInfo.value += 1
    }

    function isUpdatePermission(channelId) {
      return PostPermission.isUpdate(channelId)
    }

    function markError() {
      error.value = true
    }

    function isError() {
      return error.value === true
    }

    function bindChainPost(thisObjectId, thatObjectId, thisTypeId, thatTypeId) {
      if (thatObjectId === undefined) {
        return false
      }

      Api.chainBindInPost(thisObjectId, thatObjectId, thisTypeId, thatTypeId).catch(() => {
        markError()
      })
    }

    function setNoPermission() {
      noPermission.value = true
    }

    function readyPageOn() {
      readyPage.value = true
    }

    function createAutosave(ID) {
      autosaveInit({
        ID: ID,
        stack: {
          "content": bootData.content !== null ? JSON.stringify(bootData.content) : null,
          "scheduled_published": bootData.scheduled_published.value,
          "is_partner_links": bootData.is_partner_links,
          "comment_allow": bootData.comment_allow,
          "type_commerce": bootData.type_commerce,
          "variant_id": bootData.variant_id,
          "shop_id": bootData.shop_id,
          "category_id": bootData.category_id,
          "type_id": bootData.type_id.type_id,
          "sub_type_ids": bootData.type_id.sub_type_ids,
          "title": bootData.title,
          "slug": bootData.slug,
          "type_visibility": bootData.type_visibility,
          "type_publish": bootData.type_publish,
          "first_order": bootData.type_order.first_order,
          "repeat_order": bootData.type_order.repeat_order,
          "price_new": bootData.price.new,
          "price_old": bootData.price.old,
          "sale_type_id": bootData.sale_type_id,
          "sale_type_value": bootData.sale_type_value,
          "time_action_start": bootData.time_action.start,
          "time_action_end": bootData.time_action.end,
          "promocode": bootData.promocode,
          "activate_link": bootData.activate_link,
          "action_activate_link": bootData.action_activate_link,
          "category_multi": bootData.category_multi,
          "tags_id": bootData.tags_id,
          "rating_article": bootData.post_article.rating,
          "faq": bootData.post_article.faq,
          "title_seo": bootData.seo.title,
          "description_seo": bootData.seo.description,
        },
        stackMap: {
          "content": "content",
          "scheduled_published": "scheduled_published",
          "is_partner_links": "is_partner_links",
          "comment_allow": "comment_allow",
          "type_commerce": "type_commerce",
          "variant_id": "variant_id",
          "shop_id": "shop_id",
          "category_id": "category_id",
          "type_id": "type_id",
          "sub_type_ids": "sub_type_ids",
          "title": "title",
          "slug": "slug",
          "type_visibility": "type_visibility",
          "type_publish": "type_publish",
          "first_order": "first_order",
          "repeat_order": "repeat_order",
          "price_new": "price_new",
          "price_old": "price_old",
          "sale_type_id": "sale_type_id",
          "sale_type_value": "sale_type_value",
          "time_action_start": "time_action_start",
          "time_action_end": "time_action_end",
          "promocode": "promocode",
          "activate_link": "activate_link",
          "action_activate_link": "action_activate_link",
          "category_multi": "category_multi",
          "tags_id": "tags_id",
          "rating_article": "rating_article",
          "faq": "faq",
          "title_seo": "title_seo",
          "description_seo": "description_seo",
        },
      })
    }

    async function createDraft(
        channelId,
        typeId,
        shopId,
        promocode,
        untilDate,
        couponId,
        sourceId,
    ) {
      return createDraftInit({
        channel_id: channelId,
        type_id: typeId,
        shop_id: shopId,
        promocode: promocode,
        until_date: untilDate,
        coupon_id: couponId,
        source_id: sourceId,
      })
    }

    function getChannelId() {
      return parseInt(bootData.channel_id)
    }

    function initBootData(data) {
      bootData.status = data["post_status"]

      bootData.content = JSON.parse(data["post_content_source"] ?? "{}")

      if (data?.images) {
        bootData.images = data?.images
      }

      bootData.scheduled_published = {
        value: data["post_scheduled_published"],
        enable: data["post_scheduled_published"] !== null,
      }

      bootData.del = data["post_del"]

      bootData.channel_id = data["post_channel_id"]

      bootData.has_in_chain = data["post_has_in_chain"]

      bootData.is_partner_links = data["post_is_partner_links"]

      bootData.comment_allow = data["post_comment_allow"]

      bootData.type_commerce = data["post_type_commerce"]

      bootData.variant_id = data["post_variant_id"] ?? null

      bootData.shop_id = data["post_shop_id"]

      bootData.category_id = data["post_category_id"]

      bootData.cnt_comments = data["cnt_comments"]

      bootData.type_id = {
        type_id: data["type_id"]["type_id"],
        sub_type_ids: data["type_id"]["sub_type_ids"],
      }

      bootData.title = data["title"]

      bootData.slug = data["slug"]

      bootData.type_visibility = data["type_visibility"]

      bootData.type_publish = data["type_publish"]

      bootData.promocode_agregator = {
        has: data?.promocode_agregator.has,
        coupon_id: data?.promocode_agregator.coupon_id,
        source_id: data?.promocode_agregator.source_id,
      }

      bootData.type_order = {
        first_order: data?.type_order?.first_order ?? false,
        repeat_order: data?.type_order?.repeat_order ?? false,
      }

      bootData.price = {
        new: data["price"]["new"],
        old: data["price"]["old"],
      }

      bootData.promocode = data["promocode"]

      bootData.time_action = {
        start: data["time_action"]["start"],
        end: data["time_action"]["end"],
      }

      bootData.activate_link = data["activate_link"]

      bootData.action_activate_link = data["activate_link_open"]

      bootData.category_multi = data["category_ids"]

      bootData.sale_type_id = data["sale_type_id"]

      bootData.sale_type_value = data["sale_type_value"]

      bootData.tags_id = data?.post_tags_id ?? []

      bootData.post_article = {
        rating: data?.post_article?.rating ?? 0,
        faq: data?.post_article?.faq ?? [],
      }

      bootData.seo = {
        title: data?.seo?.title ?? "",
        description: data?.seo?.description ?? "",
      }
    }

    async function getItem(ID) {
      return Api.item(ID)
    }

    function changeUrl(post_id) {
      window.history.pushState(null, null, "/post/edit/" + post_id)
    }

    function hasPostId() {
      return postId.value !== null
    }

    function getPostId() {
      return postId.value
    }

    function getPostStatus() {
      return bootData.status
    }

    function getTypeId() {
      return bootData.type_id.type_id
    }

    function setPostId(post_id) {
      postId.value = post_id
    }

    function factorySave(q, type, typeId) {
      if (type === "scheduled") {
        if (typeId === salesTypeId) {
          return Api.scheduledSales(q)
        } else if (typeId === notesTypeId) {
          return Api.scheduledNotes(q)
        } else if (typeId === promocodeTypeId) {
          return Api.scheduledPromocode(q)
        } else if (typeId === offersTypeId) {
          return Api.scheduledSales(q)
        } else if (typeId === freeTypeId) {
          return Api.scheduledSales(q)
        } else if (typeId === foodAndProductsTypeId) {
          return Api.scheduledSales(q)
        } else if (typeId === banksTypeId) {
          return Api.scheduledSales(q)
        } else if (typeId === gamesTypeId) {
          return Api.scheduledSales(q)
        } else if (typeId === raffleTypeId) {
          return Api.scheduledSales(q)
        } else if (typeId === articlesTypeId) {
          return Api.scheduledArticles(q)
        }  else {
          throw new Error("Неверный тип поста")
        }
      } else if (type === "published") {
        if (typeId === salesTypeId) {
          return Api.publishedSales(q)
        } else if (typeId === notesTypeId) {
          return Api.publishedNotes(q)
        } else if (typeId === promocodeTypeId) {
          return Api.publishedPromocode(q)
        } else if (typeId === offersTypeId) {
          return Api.publishedSales(q)
        } else if (typeId === freeTypeId) {
          return Api.publishedSales(q)
        } else if (typeId === foodAndProductsTypeId) {
          return Api.publishedSales(q)
        } else if (typeId === banksTypeId) {
          return Api.publishedSales(q)
        } else if (typeId === gamesTypeId) {
          return Api.publishedSales(q)
        } else if (typeId === raffleTypeId) {
          return Api.publishedSales(q)
        } else if (typeId === articlesTypeId) {
          return Api.publishedArticles(q)
        } else {
          throw new Error("Неверный тип поста")
        }
      } else if (type === "save") {
        if (typeId === salesTypeId) {
          return Api.saveSales(q)
        } else if (typeId === notesTypeId) {
          return Api.saveNotes(q)
        } else if (typeId === promocodeTypeId) {
          return Api.savePromocode(q)
        } else if (typeId === offersTypeId) {
          return Api.saveSales(q)
        } else if (typeId === freeTypeId) {
          return Api.saveSales(q)
        } else if (typeId === foodAndProductsTypeId) {
          return Api.saveSales(q)
        } else if (typeId === banksTypeId) {
          return Api.saveSales(q)
        } else if (typeId === gamesTypeId) {
          return Api.saveSales(q)
        } else if (typeId === raffleTypeId) {
          return Api.saveSales(q)
        } else if (typeId === articlesTypeId) {
          return Api.saveArticles(q)
        } else {
          throw new Error("Неверный тип поста")
        }
      } else {
        throw Error("Неверный тип")
      }
    }

    function getQuery(q = {}) {
      let query = {
        "post_id": getPostId(),
        "content": bootData.content !== null ? JSON.stringify(bootData.content) : null,
        "scheduled_published": bootData.scheduled_published.value,
        "is_partner_links": bootData.is_partner_links,
        "comment_allow": bootData.comment_allow,
        "type_commerce": bootData.type_commerce,
        "variant_id": bootData.variant_id,
        "shop_id": bootData.shop_id,
        "category_id": bootData.category_id,
        "type_id": bootData.type_id.type_id,
        "sub_type_ids": bootData.type_id.sub_type_ids,
        "title": bootData.title,
        "slug": bootData.slug,
        "type_visibility": bootData.type_visibility,
        "type_publish": bootData.type_publish,
        "first_order": bootData.type_order.first_order,
        "repeat_order": bootData.type_order.repeat_order,
        "price_new": bootData.price.new,
        "price_old": bootData.price.old,
        "sale_type_id": bootData.sale_type_id,
        "sale_type_value": bootData.sale_type_value,
        "time_action_start": bootData.time_action.start,
        "time_action_end": bootData.time_action.end,
        "promocode": bootData.promocode,
        "activate_link": bootData.activate_link,
        "action_activate_link": bootData.action_activate_link,
        "category_multi": bootData.category_multi,
        "tags_id": bootData.tags_id,
        "rating_article": bootData.post_article.rating,
        "faq": bootData.post_article.faq,
        "title_seo": bootData.seo.title,
        "description_seo": bootData.seo.description,
      }

      return Helper.mergeObject(query, q);
    }

    function setValidation(data) {
      validations.value = data
    }

    function startSaving() {
      saving.value = true
    }

    function stopSaving() {
      saving.value = false
    }

    function closeModalWindow() {
      closeModal.value.click()
    }

    function onCountSellTitle(payload) {
      transactions.element = payload["element"]
      transactions.post_id = payload["post_id"]
      transactions.channel_id = getChannelId()
    }

    function onClickChainTitle(payload) {
      transactions.element = payload["element"]
      transactions.post_id = payload["post_id"]
      transactions.channel_id = getChannelId()
    }

    function isMarkAdShow() {
      return hasPostId()
    }

    function getFirstImage(images) {
      if (!images) {
        return null
      }

      return !images?.[0] ? null : images?.[0]
    }

    function isAllowDeleteForce() {
      return Permission.hasPermissions("admin_delete_force")
    }

    function isShowFloatingMenu() {
      return Helper.inArray([bootData.type_id.type_id], [
        promocodeTypeId,
        salesTypeId,
        offersTypeId,
        freeTypeId,
        foodAndProductsTypeId,
        banksTypeId,
        gamesTypeId,
        raffleTypeId,
        articlesTypeId,
      ])
    }

    function isShowBubbleMenu() {
      return Helper.inArray([bootData.type_id.type_id], [
        promocodeTypeId,
        salesTypeId,
        offersTypeId,
        freeTypeId,
        foodAndProductsTypeId,
        banksTypeId,
        gamesTypeId,
        raffleTypeId,
        articlesTypeId,
      ])
    }

    function isShowSlug() {
      if (Helper.inArray([getPostStatus()], ["draft"])) {
        return false
      }

      return true
    }

    const salePayload = computed(() => ({
      newPrice: bootData.price.new,
      oldPrice: bootData.price.old,
      saleTypeId: bootData.sale_type_id,
      saleTypeValue: bootData.sale_type_value,
      typeId: bootData.type_id.type_id,
    }))

    return {
      commentModerationObject,
      conditions,
      events,
      bootData,
      isSavingProcess,
      getPostId,
      getPostStatus,
      validations,
      accordion,
      closeModal,
      updateInfo,
      getQuery,
      onCountSellTitle,
      transactions,
      onClickChainTitle,
      chainObject,
      hasPostId,
      isMarkAdShow,
      getChannelId,
      fields,
      getTypeId,
      getFirstImage,
      isShowFloatingMenu,
      isShowBubbleMenu,
      isShowSlug,
      salePayload,
      typeId,
    }
  },
})
</script>

<style src="./css/style.css" scoped></style>
